var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 64,
    viewBox: "0 0 55 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-brands:square-x-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.85714 4.50635C3.52344 4.50635 0 8.02979 0 12.3635V51.6492C0 55.9829 3.52344 59.5063 7.85714 59.5063H47.1429C51.4766 59.5063 55 55.9829 55 51.6492V12.3635C55 8.02979 51.4766 4.50635 47.1429 4.50635H7.85714ZM44.3315 14.8188L31.5882 29.3791L46.5781 49.1938H34.8415L25.6585 37.1749L15.1373 49.1938H9.3058L22.933 33.6146L8.55692 14.8188H20.5882L28.8996 25.8066L38.5 14.8188H44.3315ZM39.6908 45.7072L18.8326 18.1213H15.3583L36.4498 45.7072H39.6786H39.6908Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.82dbeba7a812c3ca47e7edce630c3862.svg";
export { ForwardRef as ReactComponent };